<template>
  <v-container fluid pa-2 v-scroll="onScrollFunction" background class="contain_width" >
    <div id="search_box" class="searching_box">
      <v-text-field
        v-show="show_search"
        name="search_item"
        v-model="Search_data"
        @input="searchProcess()"
        label="ค้นหา..."
        style="margin-top:7px;color:#fff"
        flat
        color="white"
        class="search_text"
        append-icon
        clearable
      />
    </div>
    <filter-component :json_data ="form_filter_data" v-on:set="onCloseFormDialog" />
    <v-btn slot="activator" icon @click="searchClick()" class="btn_show_search">
      <v-icon :size="16">fa-search</v-icon>
    </v-btn>
    <v-btn slot="activator" icon @click="showFilter(true)" class="btn_show_filter">
      <v-icon :size="16">fa-filter</v-icon>
    </v-btn>
    <v-layout row wrap hidden-xs-only>
      <v-flex sm12 xs12  class="search_in_page_flex">
            <v-text-field
              solo
              label="ค้นหา..."
              v-model="Search_data"
              @input="searchProcess()"
              append-icon="search"
              style="margin-bottom: 0px;"
            ></v-text-field>
      </v-flex>
    </v-layout> 
    <v-layout row wrap hidden-xs-only>
      <v-flex xs12 sm12 class="search_in_page">
        <v-text-field
          solo
          label="ค้นหา..."
          v-model="Search_data"
          @input="searchProcess()"
          append-icon="search"
          style="margin-bottom: 0px;"
        ></v-text-field>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <!-- Create Button -->
      <v-flex md12 sm12 xs12 v-if="permission_edit == true || admin == 'true'">
        <v-tooltip top>
          <v-btn
            slot="activator"
            color="primary"
            dark
            fixed
            bottom
            right
            fab
            @click="onHandleDialog(true, 'create', null)"
          >
            <v-icon>fa-plus</v-icon>
          </v-btn>
          <span>{{$t('create')}}</span>
        </v-tooltip>
      </v-flex>
      <v-layout
        row
        align-center
        text-xs-center
        style="margin-top:5rem;margin-bottom:15rem"
        v-if="table_data.length == 0 && !showLoading"
      >
        <v-flex xs12 md4 offset-md4 lg2 offset-lg5 class="adddoc-hover" style="cursor: pointer" v-if="permission_edit == true || admin == 'true'">
          <div
            @click="onHandleDialog(true, 'create', null)"
            style="padding-top:40px;padding-bottom:40px;"
          >
            <v-icon style="font-size:80px;" color="blue">fa fa-plus</v-icon>
            <h3 class="headline mb-0" style="color:#2195F3;">{{$t('AddNewEmployee')}}</h3>
          </div>
        </v-flex>
      </v-layout>
      <!-- List -->
      <v-flex md12 sm12 xs12>
        <v-layout row wrap v-if="!showLoading">
          <v-flex lg2 md4 sm4 xs6 v-for="(item, index) in table_data" :key="index" @click="''">
             <v-card class=" boxEmp " >
               <v-card-actions>
              <v-spacer></v-spacer>
              <div class="text-center">
              <v-menu offset-y>
                  <template  slot="activator" >
                    <v-btn icon>
                            <v-icon small>fas fa-ellipsis-v</v-icon>
                          </v-btn> 
                  </template>
                  <v-card class="pa-0" max-width="344">
                     <v-card-title class="setbox" v-if="permission_edit == true || admin == 'true'"> 
                        <v-btn slot="activator" color="primary" flat  @click="_inviteClick(item)">
                        <v-icon :size = 14 style="margin-right:5px;">fa-plus</v-icon>
                        <span>{{$t('invite')}}</span>
                        </v-btn>
                      </v-card-title>
                      <v-card-title class="setbox" v-if="permission_edit == true || admin == 'true'"> 
                        <v-btn slot="activator" color="warning"  flat @click="onHandleDialog(true,'update',item)">
                            <v-icon :size = 14 style="margin-right:5px;">edit</v-icon>
                            <span>{{$t('edit')}}</span>
                        </v-btn>
                      </v-card-title>
                      <v-card-title  class="setbox" v-if="permission_edit == true || admin == 'true'">
                          <v-btn slot="activator" color="error"  flat @click="EmployeeActive(item)">
                            <v-icon :size = 16 style="margin-right:5px;">close</v-icon>
                            <span>{{$t('delete')}}</span>
                          </v-btn>
                      </v-card-title>
                  </v-card>
                  <!-- <v-card class="mx-auto" max-width="344">
                      <v-card-title>
                          <v-btn slot="activator" color="error"  flat @click="deleteItem(item)">
                            <v-icon>close</v-icon>
                            <span>{{$t('delete')}}</span>
                          </v-btn>
                      </v-card-title>
                  </v-card> -->
              </v-menu>
              </div>
            </v-card-actions>
              <v-card-title >
                <v-layout row warp style="margin-top:-25px;">
                    <v-flex md12 sm12 xs12 text-xs-center>
                    <v-avatar class="avatar"
                    v-if="item.emp_images == '' || item.emp_images == undefined  || item.emp_images == null"
                    :size="64"
                    color="teal"
                  >
                    <span style="font-size:1.5em;color:#fff;"  >{{item.nick_name}}</span>
                  </v-avatar>
                   <Empimage
                    v-if="item.emp_images != '' && item.emp_images != undefined  && item.emp_images != null"
                    :json_data="item.emp_images"
                  />
                    </v-flex>
                </v-layout>

              </v-card-title>
              <v-card-title>
                    <v-flex md12 sm12 xs12 text-xs-center>
                   <span >{{item.name_title}} {{item.first_name}} {{item.last_name}}</span>
                    </v-flex>
                      <v-flex md12 sm12 xs12 text-xs-center>
                   <span
                        v-show="isEmpty(item.nick_name) && item.nick_name != 'null'"
                        v-html="' (<span style=color:#166BFF;>'+item.nick_name+'</span>)'"
                      />
                      
                    <span 
                        v-show="item.nick_name =='' || item.nick_name == 'null'"
                        v-html="'</br>'"/>
                    </v-flex>
              </v-card-title>
        <v-divider class="mx-4" ></v-divider>
    <v-card-title>
       <v-layout row wrap>
      <v-flex lg6 md6 sm6 xs5 pa-1>
        <span >{{$t('code')}}</span>
      </v-flex>
      <v-flex lg6 md6 sm6 xs7 pa-1>
        <span class="coco-list-label-text">{{item.code}}</span>
      </v-flex>
      <v-flex lg6 md6 sm6 xs5 pa-1>
        <span >{{$t('Position')}}</span>
      </v-flex>
      <v-flex lg6 md6 sm6 xs7 pa-1>
        <span class="coco-list-label-text" >{{item.position}}</span>
      </v-flex>
      <v-flex lg6 md6 sm6 xs5 pa-1>
        <span >{{$t('TelephoneNumber')}}</span>
      </v-flex>
      <v-flex lg6 md6 sm6 xs7 pa-1>
        <span class="coco-list-label-text">{{item.phone_num}}</span>
      </v-flex>
      <v-flex lg6 md6 sm6 xs5 pa-1 v-if="item.emp_type == 0">
        <span >{{$t('Salary')}}</span>
      </v-flex>
      <v-flex lg6 md6 sm6 xs7 pa-1 v-if="item.emp_type == 0">
        <span class="coco-list-label-text" >{{item.current_salary}}</span>
      </v-flex>
       <v-flex lg6 md6 sm6 xs5 pa-1 v-if="item.resign_time == null">
        <span >{{$t('StartworkingDate')}}</span>
      </v-flex>
      <v-flex lg6 md6 sm6 xs7 pa-1 v-if="item.resign_time == null">
        <span class="coco-list-label-text" >{{dateformat(item.start_work_date)}}</span>
      </v-flex>
      <v-flex lg6 md6 sm6 xs5 pa-1 v-if="item.resign_time != null">
        <span >{{$t('ResignAt')}}</span>
      </v-flex>
      <v-flex lg6 md6 sm6 xs7 pa-1 v-if="item.resign_time != null">
        <span class="coco-list-label-text" >{{dateformat(item.resign_time)}}</span>
      </v-flex>
       </v-layout>
    </v-card-title>
  </v-card>
             <!-- <v-card class="coco-box-shadow coco-list-hover">
              <v-layout align-center justify-center row fill-height wrap class="coco-list-layout" style=" padding-top: 10px;">
                <v-flex lg1 md1 sm2 xs3 text-xs-center>
                  <v-avatar
                    v-if="item.emp_images == '' || item.emp_images == undefined  || item.emp_images == null"
                    :size="64"
                    color="teal"
                  >
                    <span class="white--text headline">{{item.nick_name}}</span>
                  </v-avatar>

                  <Empimage
                    v-if="item.emp_images != '' && item.emp_images != undefined  && item.emp_images != null"
                    :json_data="item.emp_images"
                  />
                </v-flex>
                <v-flex lg9 md9 sm8 xs9>
                  <v-layout row wrap>
                    <v-flex lg4 md6 sm12 xs12 class="content">
                      <span>{{item.first_name}} {{item.last_name}}</span>
                      <span
                        v-show="isEmpty(item.nick_name) && item.nick_name != 'null'"
                        v-html="' (<span style=color:#166BFF;>'+item.nick_name+'</span>)'"
                      />
                      <b v-show="item.emp_type == 1" style="color: #FF802C;" class="pl-1">รายวัน</b>
                      <b v-show="item.emp_type == 2" style="color: #689F38;" class="pl-1">พาทไทม์</b>
                    </v-flex>

                    <v-flex lg4 md6 sm6 xs6 class="hidden-xs-only content">
                      <span class="coco-list-label-text" v-if="item.branch_name != ''&& item.branch_name != null">
                        {{$t('branch') + ':'}}
                        <span>{{item.branch_name}}</span>
                        </span>
                         <span class="coco-list-label-text" v-if="item.branch_name != ''&& item.branch_name != null">/</span>
                         <span class="coco-list-label-text" v-if="item.department_name != ''&& item.department_name != null">
                        {{$t('Department') + ':'}}
                        <span>{{item.department_name}}</span>
                      </span>
                    </v-flex>
                    <v-flex lg4 md6 sm6 xs6 class="hidden-xs-only content">
                      <span class="coco-list-label-text" v-if="item.position != ''&& item.position != null">
                        {{$t('Position') + ' : '}}
                        <span>{{item.position}}</span>
                      </span>
                    </v-flex>
                    <v-flex lg4 md6 sm6 xs6 class="hidden-xs-only content">
                      <span class="coco-list-label-icon" v-if="item.current_salary != ''&& item.current_salary != null">
                        <v-icon :size="16" style="padding-bottom:5px;">attach_money</v-icon>
                        <span style="padding-left: 0px;">{{item.current_salary}}</span>
                      </span>
                    </v-flex>
                    <v-flex lg4 md6 sm6 xs6 class="hidden-xs-only content">
                      <span class="coco-list-label-icon" v-if="item.phone_num != '' && item.phone_num !='-' && item.phone_num != null">
                        <v-icon :size="16">fa-mobile-alt</v-icon>
                        <span
                          v-show="item.phone_num != '' && item.phone_num !='-' && item.phone_num != null"
                        >{{item.phone_num}}</span>
                      </span>
                    </v-flex>
                    <v-flex lg4 md6 sm6 xs6 class="hidden-xs-only content">
                      <span class="hidden-sm-and-down coco-list-label-icon" v-if="item.email != '' && item.email !='-' && item.email != null">
                        <v-icon :size="16">fa-envelope</v-icon>
                        <span
                          v-show="item.email != '' && item.email !='-' && item.email != null"
                        >{{item.email}}</span>
                      </span>
                    </v-flex>

                    <v-flex xs12 class="hidden-sm-and-up">
                      <span class="coco-list-label-text">
                        {{$t('branch') + ' : '}}
                        <span>{{item.branch_name}}</span>
                      </span>
                    </v-flex>
                    <v-flex xs12 class="hidden-sm-and-up">
                      <span xs12 class="coco-list-label-text">
                        {{$t('Department') + ' : '}}
                        <span>{{item.department_name}}</span>
                      </span>
                    </v-flex>
                    <v-flex xs12 class="hidden-sm-and-up">
                      <span class="coco-list-label-text">
                        {{$t('Position') + ' : '}}
                        <span>{{item.position}}</span>
                      </span>
                    </v-flex>
                    <v-flex xs12 class="hidden-sm-and-up">
                      <span class="coco-list-label-icon">
                        <v-icon :size="16" style="padding-bottom:3px;">attach_money</v-icon>
                        <span >{{item.current_salary}}</span>
                      </span>
                      <span
                        style="margin-left:20px"
                        v-show="item.phone_num != '' && item.phone_num !='-' && item.phone_num != null"
                        class="coco-list-label-icon"
                      >
                        <v-icon :size="16">fa-mobile-alt</v-icon>
                        <span>{{item.phone_num}}</span>
                      </span>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex lg2 md2 sm2 xs2>
                  <v-layout row wrap class="hidden-xs-only">
                    <v-flex md12 sm12 xs12 text-xs-center>
                      <v-layout row wrap>
                        <v-flex offset-lg5 offset-md3 lg3 md4 xs6 v-if="check_permission == true || admin == 'true'">
                          <v-tooltip bottom>
                            <v-btn
                              slot="activator"
                              color="warning"
                              icon
                              flat
                              @click="onHandleDialog(true,'update',item)"
                            >
                              <v-icon>edit</v-icon>
                            </v-btn>
                            <span>{{$t('edit')}}</span>
                          </v-tooltip>
                        </v-flex>
                        <v-flex lg3 md4 xs6 v-if="check_permission == true || admin == 'true'">
                          <v-tooltip bottom>
                            <v-btn
                              slot="activator"
                              color="error"
                              icon
                              flat
                              @click="EmployeeActive(item)"
                            >
                              <v-icon>close</v-icon>
                            </v-btn>
                            <span>{{$t('delete')}}</span>
                          </v-tooltip>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 class="hidden-sm-and-up" >
                  <v-layout row wrap>
                    <v-flex md12 sm12 xs12 text-xs-center>
                      <v-layout row wrap>
                        <v-flex offset-xs8 xs2 v-if="check_permission == true || admin == 'true'">
                          <v-tooltip bottom>
                            <v-btn
                              slot="activator"
                              color="warning"
                              icon
                              flat
                              @click="onHandleDialog(true,'update',item)"
                            >
                              <v-icon>edit</v-icon>
                            </v-btn>
                            <span>{{$t('edit')}}</span>
                          </v-tooltip>
                        </v-flex>
                        <v-flex xs2 v-if="check_permission">
                          <v-tooltip bottom>
                            <v-btn
                              slot="activator"
                              color="error"
                              icon
                              flat
                              @click="deleteItem(item)"
                            >
                              <v-icon>close</v-icon>
                            </v-btn>
                            <span>{{$t('delete')}}</span>
                          </v-tooltip>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 offset-md1 offset-sm2 class="coco-list-divider" style="margin-top : 10px;">
                  <v-divider />
                </v-flex>
              </v-layout>
            </v-card> -->
          </v-flex>
        </v-layout>
      </v-flex>
      <!-- pagination -->
       <v-layout row wrap my-2>
      <v-flex xs12 >
        <div class="show_pagination_fixed" >
          <v-pagination fixed v-model="pageActive" :length="totalPages" :total-visible="7" circle  @input="getEmployeeList('List')"></v-pagination>
        </div>
      </v-flex>
    </v-layout>
      <!-- Delete Dialog -->
      <v-flex md12 sm12 xs12>
        <delete-dialog
          :json_data="delete_dialog_data"
          v-on:close-dialog="onCloseDeleteDialog"
          v-on:delete-item="onDelete"
        />
      </v-flex>
      <!-- invite dialog -->
      <v-flex>
         <v-dialog v-model="invite_dialog" max-width="300">
      <v-card>
        <v-card-title class="headline blue darken-1" primary-title style="color:white">
          {{$t('Send_invite')}}
        </v-card-title>
        <v-card-text>
           <v-layout row wrap pa-3>
          <v-flex xs12 style="margin-top:15px;">
           
           {{$t('Send_invitation')}} {{inviteDetail}}
          <p>{{inviteDetailEmailTel}}</p>
          
          </v-flex>
           </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" text @click="invite_dialog = false">{{$t('cancel')}}</v-btn>
          <v-btn color="primary" text @click="sendInvite()">{{$t('send')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
      </v-flex>
      <!-- FormDialog -->
      <v-flex md12 sm12 xs12>
        <frm-dialog :json_data="form_dialog_data" v-on:close-dialog="onCloseFormDialog" />
      </v-flex>
      <!-- Snackbar -->
      <v-snackbar
        v-model="snack_model.status"
        :timeout="3500"
        :top="'top'"
        :color="snack_model.type"
      >
        {{ snack_model.msg }}
        <v-btn dark flat icon @click="snack_model.status = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-snackbar>
    </v-layout>
  </v-container>
</template>
<script>
/* eslint-disable */
import { mapState, mapActions, mapMutations, mapGetters } from "vuex";
import EmployeeService from "@/services/EmployeeService";
import Empimage from "../../components/getempimage.vue";
import FrmDialog from "./FormDialog";
import DeleteDialog from "../../components/master/dialogs/DeleteDialog";
import Utils from "@/utils/";
import $ from "jquery";
import FilterComponent from "./Filter";
import moment from "moment";
import UserService from "@/services/UserService";
export default {
  data: () => ({
    item: 1,
      items: [
        { text: 'Real-Time', icon: 'mdi-clock' },
        { text: 'Audience', icon: 'mdi-account' },
        { text: 'Conversions', icon: 'mdi-flag' },
      ],
    Search_data: "",
    
    show_search: false,
    form_dialog_data: {
      status: false,
      save_type: String,
      data: Object
    },
    form_filter_data: {
      status: false,
     
    },
    delete_dialog_data: {
      status: false
    },
    snack_model: {
      status: "",
      msg: "",
      type: ""
    },
    img_not_found: "@/assets/user.png",
    table_data: [],
    pageActive: 1,
    totalPages:0,
    onload: false,
    processing: false,
    canLoadMore: true,
    timeout: null,
    admin:false,
    permission_edit:false,
    permission_view:false,
    empCode: localStorage._empcode,
    permission:[],
    invite_dialog:false,
    invite_usercode:"",
    inviteDetail: "",
    inviteDetailEmailTel : "",
    inviteEmail: "",
    inviteTel : "",
  }),
  created: async function() {
    this.admin = localStorage._is_admin;
    await  UserService.getpermissionByusercode(this.empCode)
    .then(res=>{
      this.permission = res.data.permission;
      console.log(res)
    })
     .catch(err => {});


    await this.checkpermission("EmployeeList")
    
    
    // this.setShowFilter({
    //   status: 2
    // });
    this.commitSetToolbar({
      patternTool: "0"
    });
    this.onload = true;

    this.getEmployeeList("Form");
    
    let v = this;
  },
  destroyed: function() {
    this.commitToggleAlertDialog({
      status: false,
      message: Object
    });
  },
  components: {
    FrmDialog,
    DeleteDialog,
    Empimage,
    FilterComponent
  },
  computed: {
    ...mapState("filter", [
      "SelectBranch",
      "SelectDepartment",
      "SelectPosition",
      "SearchData",
      "FromDate",
      "ToDate"
    ]),
    ...mapState("app", ["showLoading"]),
    ...mapState("filter", ["loading", "Employee_List"]),
   // ...mapState("permissionmenu", ["permission_List"])
  },
  methods: {
    ...mapMutations("filter", ["setShowFilter"]),
    ...mapActions("filter", ["setSearchData"]),
    ...mapActions("app", ["commitSetToolbar", "commitSetShowLoading"]),
    ...mapActions("alert", ["commitToggleAlertDialog"]),
    ...mapActions("filter", ["getEmployee"]),
    // ...mapActions("permissionmenu", ["getPermissionEdit"]),
    // ...mapMutations("permissionmenu", ["getAllPermission"]),
    onCloseFormDialog() {
      this.form_dialog_data.status = false;
      this.onload = true;
      this.getEmployee("newData");
      this.getEmployeeList("Form");
    },
     dateformat(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    searchProcess() {
      var v = this;
      clearTimeout(this.timeout);
      this.timeout = setTimeout(function() {
        v.getEmployeeList("Filter");
      }, 1500);
    },
    searchClick() {
      if (this.show_search) {
        this.show_search = false;
        $('#pagetitleshow').removeClass('showtitlepage')
      } else {
        this.show_search = true;
        $('#pagetitleshow').addClass('showtitlepage')
        //console.log($('#pagetitleshow'))
      }
    },
    showFilter(status){
      this.form_filter_data = {
        status: status,
        data:1
      };
    },
   checkpermission(page){
        let checkEdit = false
        let checkView = false
        if(this.permission.length != 0){
             this.permission.forEach(element => {
                 if(page == element.module_name){
                    checkEdit = element.edit;
                    checkView = element.reads;
                 }
             });
        }
        else{
            checkEdit = false;
            checkView = false;
        }
        this.permission_edit = checkEdit
        this.permission_view = checkView
    },
    onCloseDeleteDialog() {
      this.delete_dialog_data.status = false;
    },
    onHandleDialog(status, save_type, data) {
      this.form_dialog_data = {
        status: status,
        save_type: save_type,
        data: data
      };
       //console.log("5555",this.form_dialog_data);
    },
    onScrollFunction(e) {
      let win_scroll_top = e.target.defaultView.pageYOffset;
      let win_height = window.innerHeight;
      let doc_height = document.body.scrollHeight;

      ////console.log("win_scroll_top " + win_scroll_top);
      let width = $(".contain_width").width();
      ////console.log("width " + width);
      if (win_scroll_top > 100) {
        $(".search_in_page").show();
        $(".search_in_page").css("width", width);
      } else {
        $(".search_in_page").hide();
      }
      /* if (win_scroll_top >= (doc_height - win_height) * 0.99) {
        if (!this.processing && this.canLoadMore) {
          this.pageActive += 1;
          //this.getEmployeeList('List');
          //console.log('last');
        }
        if(this.processing && this.canLoadMore){
          //console.log('not last');
        }
       }*/
    },
    showSnackBar(msg, type) {
      this.snack_model.msg = msg;
      this.snack_model.type = type;
      this.snack_model.status = true;
    },
    EmployeeActive(data) {
      this.delete_dialog_data.status = true;
      let message =
        "<p>" +
        this.$t("question.inactive") +
        " " +
        data.code +
        " " +
        data.first_name +
        " " +
        data.last_name +
        "?</p>";
      this.delete_dialog_data.message = message;
      this.delete_dialog_data.code = data.code;
    },
    isEmpty(value) {
      return Utils.isEmpty(value);
    },
    getEmployeeList(Action) {
      this.processing = true;
      this.commitSetShowLoading(true);

      //console.log("Search" + this.SearchData);

      EmployeeService.getEmployee(
        this.SelectBranch,
        this.SelectDepartment,
        this.SelectPosition,
        this.Search_data,
        this.pageActive
      )
        .then(res => {
          console.log(res)
          var user_img = "";
          if (this.table_data.length > 0 && Action == "List") {
            if (res.data.content.length > 0) {
              this.table_data= [];
              res.data.content.forEach(data => {
                this.table_data.push(data);
              });
              this.totalPages = res.data.totalPages;
              
            } else {
              this.canLoadMore = false;
            }
          } else {
            this.table_data = res.data.content;
           // console.log("fffff",res);
            this.totalPages = res.data.totalPages;
            //console.log(this.table_data);
          }
        })
        .catch(err => {
          this.commitToggleAlertDialog({
            status: true,
            message: err.response.data
          });
        })
        .then(() => {
          this.commitSetShowLoading(false);
          this.processing = false;
        });
    },
    onDelete() {
      this.commitSetShowLoading(true);
      EmployeeService.EmployeeActive(this.delete_dialog_data.code)
        .then(res => {
          this.snack_model.status = true;
          this.snack_model.msg = this.$t("message.delete");
          this.snack_model.type = "success";
          this.onload = true;
          this.getEmployeeList();
          this.delete_dialog_data.status = false;
        })
        .catch(err => {
          this.commitToggleAlertDialog({
            status: true,
            message: err.response.data
          });
        })
        .then(() => {
          this.commitSetShowLoading(false);
        });
    },
    _inviteClick(data){
      console.log(data);
      let rowEdit = data
      this.invite_usercode = rowEdit.code;
      this.inviteDetail = rowEdit.first_name + ' ' + rowEdit.last_name;
      this.inviteDetailEmailTel = 'Email : ' + rowEdit.email ;
      this.inviteEmail = rowEdit.email;
      this.inviteTel = '';
      this.invite_dialog = true;
    },
    sendInvite() {
      let data = [] ;
      data.push({
            email: this.inviteEmail,
            telephone:''
      });
    console.log(data)
    UserService._sendInvite(data)
    .then(res => {
      console.log(res)
      if (res.data[0].token != '' && res.data[0].token != null) {
        UserService._saveInviteToken(res.data[0].token, this.invite_usercode)
        .then(res => {
          this.showSnackBar(this.$t("message.invite"),'success');
        })
        .catch(err => {
           this.showSnackBar(this.$t("message.errorinvite"),'error');
        });
      } else {
         this.showSnackBar(this.$t("message.invitefail"),'error');
      }
      this.invite_dialog = false;
    })
    .catch(err => {
      this.showSnackBar(this.$t("message.invitefail"),'error');
    });
  }
  }
};
</script>
<style>
@import url("https://fonts.googleapis.com/css?family=Prompt");

span {
  font-family: "Prompt", sans-serif;
}
.content {
  margin-top: 5px;
  margin-bottom: 5px;
}
.setbox{
padding: 0px !important;
text-align: left;
width: 100px;
}
.background {
  background: url("../../assets/banner1.png") no-repeat fixed top;
  }
  .boxEmp{
  width: 90% !important;
  height: 430px !important;
  border-radius: 10px !important;
  background-color: #ffffff ;
  margin:10px;
  box-shadow: 0 10px 6px -6px #b4b4b4;
  text-align: left;
 
}

@media screen and (min-width: 1366px){
.boxEmp{
  width: 90% !important;
  height: 430px !important;
  border-radius: 10px !important;
  background-color: #ffffff ;
  margin:10px;
  box-shadow: 0 10px 6px -6px #b4b4b4;
  text-align: left;
 
}
}
/* mobile  ----------- */
@media screen and  (max-width: 812px) {
  #header_message {
    visibility: hidden;
    clear: both;
    float: left;
    width: 28%;
    display: none;
    margin-right: 0px !important;
  }
  .container-fluid {
    padding-left: 10px !important;
    padding-right: 10px !important;
  }
  .display_none1 {
    display: none;
  }
  .boxEmp{
  width: 95% !important;
  height: 350px !important;
  border-radius: 10px !important;
  background-color: #ffffff ;
  box-shadow: 0 10px 6px -6px #b4b4b4;
  margin:5px;
  text-align: left;
  font-size: 0.7em;
 
}
  
}
 
.font-menu{
  font-size: 0.5rem ;
}
.icon-menu{
  font-size: 2rem ;
}
/* tablet  ----------- */
@media screen and (min-width: 768px) and (max-width: 1024px){
  #header_message {
    margin: 0px 25px 0px 0px !important;
  }
  .display_none1 {
    display: none;
  }
  .boxEmp{
  width: 90% !important;
  height: 400px !important;
  border-radius: 10px !important;
  background-color: #ffffff ;
  box-shadow: 0 10px 6px -6px #b4b4b4;
  margin:10px;
  text-align: left;
   font-size: 0.9em;
   
 
}
}

/* ipad pro  ----------- */
@media screen and (min-width: 1024px) and (max-width: 1366px) {
  #header_message {
    margin: 0px 25px 0px 0px !important;
  }
  .display_none1 {
    display: none;
  }
   .boxEmp{
  width: 90% !important;
  height: 420px !important;
  border-radius: 10px !important;
  background-color: #ffffff ;
  box-shadow: 0 10px 6px -6px #b4b4b4;
  margin:10px;
  text-align: left;
 font-size: 1em;
}

}

@media screen and (min-width: 1200px) and (max-width: 3000px) {
  #header_message {
    margin: 0px 25px 0px 0px !important;
  }
  .display_none {
    display: none;
  }
   .boxEmp{
  width: 95% !important;
  height: 400px !important;
  border-radius: 10px !important;
  background-color: #ffffff ;
  box-shadow: 0 10px 6px -6px #b4b4b4;
  margin:5px;
  text-align: left;
  font-size: 0.9em;
 
}
}

/* iPads (landscape) ----------- */
@media only screen and (min-device-width: 768px) and (max-device-width: 1200px) and (orientation: landscape) {
  #header_message {
    margin: 0px 25px 0px 0px !important;
  }
  .display_none {
    display: block;
  }
}
/* iPads (portrait) ----------- */
@media only screen and (min-device-width: 768px) and (max-device-width: 1200px) and (orientation: portrait) {
  #header_message {
    margin: 0px 25px 0px 0px !important;
  }
  .display_none {
    display: block;
  }
}
.box-pointer {
  cursor: pointer;
  margin-bottom: 20px;
  margin-top: 20px;
}

.box-pointer-vdo {
  cursor: pointer;
}
.avoid-clicks {
  pointer-events: none;
}
.avatar{
height: 64px !important;
width: 64px !important;
}
.showtool{
z-index: 2;
}
</style>
